import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class GatewatNotification extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/gateway/notification'
    super(store, path)
  }
}
